import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'
import { Permission } from './permissions'

export const responseConfigurationPageAccessControl: DomainAccessControlConfig = [
  {
    featureToggles: [FeatureToggle.fulfillmentPartnerIntegrationsResponseConfigurations],
    permissions: [Permission.ResponseConfigurationsView, Permission.ResponseConfigurationsModify],
  },
  {
    warehouseFeatureToggles: [FeatureToggle.fulfillmentPartnerIntegrationsResponseConfigurations],
    permissions: [Permission.ResponseConfigurationsView, Permission.ResponseConfigurationsModify],
  },
]
